
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 127.862 127.862"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M121.797 0A127.862 127.862 0 000 127.646a127.862 127.862 0 00.008.215H127.86V0h-6.064z","fill":"#f7adcb"}}),_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h127.862v127.862H0z"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"xlink:href":"#a","overflow":"visible","width":"100%","height":"100%"}})])])
          )
        }
      }
    